export default __webpack_public_path__ + "components/weather-icon/static/nightthunderstorm-2c2cc51b17a69a4c15cf539ecd18ec2d.svg";